// router/empresa/sucursal/compras.routes.js

export default [
  {
    path: 'compras',
    name: 'empresa.sucursal.compras.listado',
    component: () => import('@/views/empresa/compras/ComprasEmpresaListado.vue'),
  },

  // Pedidos de compra
  {
    path: 'pedido',
    name: 'empresa.sucursal.compras.pedido.listado',
    component: () => import('@/views/empresa/compras/pedido/CompraPedidoEmpresaHome.vue'),
  },
  {
    path: 'pedido/registrar',
    name: 'empresa.sucursal.compras.pedido.registrar',
    component: () => import('@/views/empresa/compras/pedido/CompraPedidoEmpresaRegistrar.vue'),
  },
  {
    path: 'pedido/:id',
    name: 'empresa.sucursal.compras.pedido.consultar',
    component: () => import('@/views/empresa/compras/pedido/CompraPedidoEmpresaConsultar.vue'),
  },
  {
    path: 'pedido/:id/editar',
    name: 'empresa.sucursal.compras.pedido.editar',
    component: () => import('@/views/empresa/compras/pedido/CompraPedidoEmpresaEditar.vue'),
  },

  // Facturas de compra
  {
    path: 'factura',
    name: 'empresa.sucursal.compras.factura.listado',
    component: () => import('@/views/empresa/sucursales/compras/CompraSucursalFacturaHome.vue'),
  },
  {
    path: 'factura/registrar',
    name: 'empresa.sucursal.compras.factura.registrar',
    component: () => import('@/components/shared/compras/factura/CompraFacturaEmpresaRegistrar.vue'),
  },
  {
    path: 'factura/:uuid_factura',
    name: 'empresa.sucursal.compras.factura.consultar',
    component: () => import('@/components/shared/compras/factura/CompraFacturaEmpresaConsultar.vue'),
  },

  // Remitos
  {
    path: 'remito',
    name: 'empresa.sucursal.compras.remito.listado',
    component: () => import('@/views/empresa/compras/remito/CompraRemitoEmpresaHome.vue'),
  },
]
